<template>
  <div>
    <!-- 二级导航 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="activeTab = tab.label">{{ tab.label }}</span>
      </div>
      <div class="refresh-btn">
        <button @click="onRefresh" style="background:#4caf50;color:#fff;border:none;padding:4px 16px;border-radius:4px;">刷新</button>
      </div>
    </div>
    <!-- 内容区 -->
    <div v-if="activeTab === '数据监控'">
      <!-- 筛选表单 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>选择设备状态：</label>
              <select class="form-input" v-model="query.fac_state">
                <option value="">全部</option>
                <option value="正常">正常</option>
                <option value="故障">故障</option>
              </select>
            </div>
            <div class="form-item">
              <label>所属厂区：</label>
              <select class="form-input" v-model="query.factory_area">
                <option value="">全部</option>
                <option v-for="area in options.factory_area" :key="area" :value="area">{{ area }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>所属楼号：</label>
              <select class="form-input" v-model="query.building_number">
                <option value="">全部</option>
                <option v-for="building in options.building_number" :key="building" :value="building">{{ building }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>所属楼层：</label>
              <select class="form-input" v-model="query.floor">
                <option value="">全部</option>
                <option v-for="floor in options.floor" :key="floor" :value="floor">{{ floor }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>设备类型：</label>
              <select class="form-input" v-model="query.fac_type">
                <option value="">全部</option>
                <option value="0">温湿度表</option>
                <option value="1">压力表</option>
              </select>
            </div>
            <div class="form-item">
              <label>设备编号：</label>
              <input class="form-input" v-model="query.fac_id" placeholder="设备编号" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onSearch">查询</button>
            <button type="button" class="search-btn-green" @click="printData">打印</button>
            <!-- <button type="button" class="clear-btn" @click="onClear">清空</button> -->
          </div>
        </form>
      </div>
      <!-- 数据表格 -->
      <div class="data-section">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
          <div class="loading-spinner"></div>
          <div class="loading-text">正在加载数据...</div>
        </div>
        
        <!-- 错误状态 -->
        <div v-else-if="error" class="error-container">
          <div class="error-icon">⚠️</div>
          <div class="error-text">{{ error }}</div>
          <button @click="fetchData" class="retry-btn">重试</button>
        </div>
        
        <div class="table-container" v-else>
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>设备编号</th>
                <th>设备名称</th>
                <th>表具数值</th>
                <th>设备类型</th>
                <th>设备状态</th>
                <th>安装位置</th>
                <th>更新时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in tableData" :key="item.fac_id">
                <td>{{ idx + 1 }}</td>
                <td>{{ item.fac_id }}</td>
                <td>{{ item.fac_name || '-' }}</td>
                <td>
                  <span v-if="item.warn" style="color: red;">{{ item.fac_data || '-' }}</span>
                  <span v-else style="color: black;">{{ item.fac_data || '-' }}</span>
                </td>
                <td>{{ item.fac_type }}</td>
                <td>{{ item.fac_state || '-' }}</td>
                <td>{{ item.install_area || '-' }}</td>
                <td>{{ item.update_date || '-' }}</td>
                <td>
                  <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="generateChart(item)">
                    实时曲线
                  </button>
                </td>
              </tr>
              <tr v-if="tableData.length === 0">
                <td colspan="11" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="currentPage===1" @click="currentPage=1;fetchData()">«</button>
          <button class="page-btn" :disabled="currentPage===1" @click="currentPage--;fetchData()">‹</button>
          <span v-for="p in displayPages" :key="p">
            <button class="page-btn" :class="{active:currentPage===p}" @click="currentPage=p;fetchData()">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="currentPage===totalPages" @click="currentPage++;fetchData()">›</button>
          <button class="page-btn" :disabled="currentPage===totalPages" @click="currentPage=totalPages;fetchData()">»</button>
          <div class="page-jump">
            <input type="text" v-model="pageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpPage">跳转</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="activeTab === '地图监控'">
      <div style="display:flex;align-items:flex-start;">
        <!-- 左侧树结构 -->
        <div style="width:220px;min-width:180px;max-width:260px;background:#fafbfc;border-right:1px solid #eee;padding:16px 8px 0 0;">

          <ul class="tree-list">
            <li>
              <span @click="toggleTree('105号楼')" class="tree-node">{{ treeOpen['105号楼'] ? '▼' : '▶' }} 105号楼</span>
              <ul v-show="treeOpen['105号楼']">
                <li>
                  <span @click="selectMapImage('105号楼二楼')" class="tree-leaf" :class="{active: selectedMap === '105号楼二楼'}">二楼</span>
                </li>
                <li>
                  <span @click="selectMapImage('105号楼三楼')" class="tree-leaf" :class="{active: selectedMap === '105号楼三楼'}">三楼</span>
                </li>
              </ul>
            </li>
            <li>
              <span @click="toggleTree('空调机房')" class="tree-node">{{ treeOpen['空调机房'] ? '▼' : '▶' }} 空调机房</span>
              <ul v-show="treeOpen['空调机房']">
                <li>
                  <span @click="selectMapImage('空调机房外围')" class="tree-leaf" :class="{active: selectedMap === '空调机房外围'}">空调机房外围</span>

                </li>

              </ul>
            </li>
          </ul>
        </div>
        <!-- 右侧地图显示 -->
        <div style="flex:1;padding:24px 32px;min-height:600px;">
          <div style="font-weight:bold;font-size:18px;margin-bottom:12px;">地图详情</div>
          <div v-if="selectedMap" style="text-align:center;">
            <img 
              :src="`/images/map/${selectedMap}.png`" 
              :alt="selectedMap" 
              :class="selectedMap === '空调机房外围' ? 'map-image-small' : 'map-image-normal'"
            />
            <div style="margin-top:12px;color:#666;font-size:14px;">{{ selectedMap }}</div>
          </div>
          <div v-else style="text-align:center;color:#999;padding:60px 20px;">
            请从左侧选择要查看的地图
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { HTTP_CONFIG } from '@/config/config.js'

export default {
  name: 'EnvMonitor',
  data() {
    return {
      tabs: [
        { label: '数据监控' },
        { label: '地图监控' }
      ],
      activeTab: '数据监控',
      query: {
        fac_state: '',
        factory_area: '',
        building_number: '',
        floor: '',
        fac_type: '',
        fac_id: '' // 确保初始化为空字符串
      },
      // 动态选项数组
      options: {
        factory_area: [],
        building_number: [],
        floor: [],
        install_area: []
      },
      tableData: [],
      treeOpen: {
        '105号楼': true
      },
      selectedMap: '105号楼二楼', // 默认选中105号楼二楼
      // 分页相关
      currentPage: 1,
      totalPages: 1,
      total: 0,
      pageInput: '1',
      loading: false,
      error: null,
      lastQuery: null // 用于存储上一次的查询条件，以便判断是否需要更新选项
    }
  },
  mounted() {
    this.fetchData()
    this.fetchOptions()
  },
  watch: {
    // 监听筛选条件变化，更新相关选项
    'query.fac_type'() {
      this.updateOptions()
    },
    'query.factory_area'() {
      this.updateOptions()
    },
    'query.building_number'() {
      this.updateOptions()
    },
    'query.floor'() {
      this.updateOptions()
    },
    // 监听tab切换，当切换到数据监控时自动更新选项
    activeTab(newTab) {
      if (newTab === '数据监控') {
        this.updateOptions()
      }
    }
  },
  computed: {
    // 新增：生成显示的页码范围，最多显示10页
    displayPages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  methods: {
    // 获取所有选项数据
    async fetchOptions() {
      try {
        await Promise.all([
          this.fetchFactoryAreaOptions(),
          this.fetchBuildingNumberOptions(),
          this.fetchFloorOptions(),
          this.fetchInstallAreaOptions()
        ])
      } catch (error) {
        console.error('获取选项数据失败:', error)
      }
    },
    generateChart(item) {
      const BeijingTime = new Date(new Date());
      const targetDate = BeijingTime.toISOString().slice(0, 10);
      this.$router.push({
        path: '/home/history/chart',
        query: {
          fac_id: item.fac_id,
          deviceName: item.fac_name,
          deviceType: item.fac_type,
          targetDate: targetDate
        }
      }).then(() => {
        console.log('路由跳转成功');
      }).catch(err => {
        console.error('路由跳转失败:', err);
      });
    },

    // 获取厂区选项
    async fetchFactoryAreaOptions() {
      try {
        const params = {}
        if (this.query.fac_type) params.fac_type = this.query.fac_type
        if (this.query.building_number) params.building_number = this.query.building_number
        if (this.query.floor) params.floor = this.query.floor
        if (this.query.install_area) params.install_area = this.query.install_area
        
        const response = await axios.get(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_fac_area_list/`, { params })
        if (response.data && response.data.factory_area) {
          this.options.factory_area = Array.from(response.data.factory_area).filter(Boolean)
        }
      } catch (error) {
        console.error('获取厂区选项失败:', error)
      }
    },

    // 获取楼号选项
    async fetchBuildingNumberOptions() {
      try {
        const params = {}
        if (this.query.fac_type) params.fac_type = this.query.fac_type
        if (this.query.factory_area) params.factory_area = this.query.factory_area
        if (this.query.floor) params.floor = this.query.floor
        if (this.query.install_area) params.install_area = this.query.install_area
        
        const response = await axios.get(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_building_number_list/`, { params })
        if (response.data && response.data.building_number) {
          this.options.building_number = Array.from(response.data.building_number).filter(Boolean)
        }
      } catch (error) {
        console.error('获取楼号选项失败:', error)
      }
    },

    // 获取楼层选项
    async fetchFloorOptions() {
      try {
        const params = {}
        if (this.query.fac_type) params.fac_type = this.query.fac_type
        if (this.query.factory_area) params.factory_area = this.query.factory_area
        if (this.query.building_number) params.building_number = this.query.building_number
        if (this.query.install_area) params.install_area = this.query.install_area
        
        const response = await axios.get(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_floor_list/`, { params })
        if (response.data && response.data.floor) {
          this.options.floor = Array.from(response.data.floor).filter(Boolean)
        }
      } catch (error) {
        console.error('获取楼层选项失败:', error)
      }
    },

    // 获取详细地址选项
    async fetchInstallAreaOptions() {
      try {
        const params = {}
        if (this.query.fac_type) params.fac_type = this.query.fac_type
        if (this.query.factory_area) params.factory_area = this.query.factory_area
        if (this.query.building_number) params.building_number = this.query.building_number
        if (this.query.floor) params.floor = this.query.floor
        
        const response = await axios.get(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_install_area_list/`, { params })
        if (response.data && response.data.install_area) {
          this.options.install_area = Array.from(response.data.install_area).filter(Boolean)
        }
      } catch (error) {
        console.error('获取详细地址选项失败:', error)
      }
    },

    // 智能更新选项
    async updateOptions() {
      try {
        // 根据当前筛选条件，只更新相关的选项
        const promises = []
        
        // 如果设备类型变化，需要更新所有相关选项
        if (this.query.fac_type !== this.lastQuery?.fac_type) {
          promises.push(
            this.fetchFactoryAreaOptions(),
            this.fetchBuildingNumberOptions(),
            this.fetchFloorOptions(),
            this.fetchInstallAreaOptions()
          )
        }
        // 如果厂区变化，需要更新楼号、楼层、详细地址选项
        else if (this.query.factory_area !== this.lastQuery?.factory_area) {
          promises.push(
            this.fetchBuildingNumberOptions(),
            this.fetchFloorOptions(),
            this.fetchInstallAreaOptions()
          )
        }
        // 如果楼号变化，需要更新楼层、详细地址选项
        else if (this.query.building_number !== this.lastQuery?.building_number) {
          promises.push(
            this.fetchFloorOptions(),
            this.fetchInstallAreaOptions()
          )
        }
        // 如果楼层变化，只需要更新详细地址选项
        else if (this.query.floor !== this.lastQuery?.floor) {
          promises.push(this.fetchInstallAreaOptions())
        }
        
        if (promises.length > 0) {
          await Promise.all(promises)
        }
        
        // 保存当前查询条件用于下次比较
        this.lastQuery = { ...this.query }
      } catch (error) {
        console.error('更新选项失败:', error)
      }
    },

    async fetchData() {
      try {
        this.loading = true
        const params = {
          page: this.currentPage,
          per_page: 20,
          ...this.query
        }
        
        // 过滤掉空值参数，确保fac_id作为字符串处理
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        
        // 确保fac_id作为字符串发送
        if (this.query.fac_id) {
          params.fac_id = String(this.query.fac_id)
        }
        
        const response = await axios.get(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_realtime_meter_message/`, {
          params: params
        })
        this.tableData = []
        if (response.data) {
          let recvData = []
          recvData = response.data.data || []
          for(let i=0;i<recvData.length;i++) {
            let node = {}
            node.fac_id = recvData[i].fac_id
            node.fac_name = recvData[i].fac_name
            let fac_data = recvData[i].fac_data
            if(fac_data != null) {
              if(node.fac_name == "气压力表") {
                let qiyaStr = fac_data.match(/\d+/g)
                let qiyaF = parseFloat(qiyaStr[0]) / 1000
                let fac_data_f = qiyaF.toFixed(2)
                let qiyaup = parseFloat(recvData[i].pressure_max)
                let qiyadown = parseFloat(recvData[i].pressure_min)
                if(fac_data_f < qiyadown || fac_data_f > qiyaup) {
                  node.warn = true
                }
                else {
                  node.warn = false
                }
                node.fac_data = fac_data_f.toString() + "MPa"
              }
              else if(node.fac_name == "温湿度表") {
                let wenshiduStr = fac_data.match(/[-]?\d+\.\d+/g)
                let wenduF = parseFloat(wenshiduStr[0])
                let shifuF = parseFloat(wenshiduStr[1])
                let wenduup = parseFloat(recvData[i].temperature_max)
                let wendudown = parseFloat(recvData[i].temperature_min)
                let shiduup = parseFloat(recvData[i].humidity_max)
                let shidudown = parseFloat(recvData[i].humidity_min)
                if(wenduF < wendudown || wenduF > wenduup || shifuF > shiduup || shifuF < shidudown) {
                  node.warn = true
                }
                else {
                  node.warn = false
                }
                node.fac_data = wenduF.toString() + "℃/" + shifuF.toString() + "%RH"
              }
            }
            else {
              node.warn = false
            }
            node.fac_type = recvData[i].fac_type
            node.fac_state = recvData[i].fac_state
            node.install_area = recvData[i].install_area
            node.update_date = recvData[i].update_date
            this.tableData.push(node)
          }
          this.total = response.data.total || 0
          this.currentPage = parseInt(response.data.current_page) || 1
          this.totalPages = response.data.total_pages || 1
          this.error = null
        }
      } catch (error) {
        // console.error('获取数据失败:', error)
        // if (error.code === 'ERR_NETWORK') {
        //   this.error = '网络连接失败，请检查网络连接或联系管理员'
        // } else if (error.response?.status === 0) {
        //   this.error = '无法连接到服务器，请检查服务器状态或网络连接'
        // } else if (error.response?.status === 403) {
        //   this.error = '访问被拒绝，请检查权限设置'
        // } else if (error.response?.status === 404) {
        //   this.error = '接口不存在，请检查API地址'
        // } else if (error.response?.status >= 500) {
        //   this.error = '服务器内部错误，请稍后重试'
        // } else {
        //   this.error = error.message || '获取数据失败，请稍后重试'
        // }
        this.tableData = []
        this.total = 0
        this.totalPages = 1
      } finally {
        this.loading = false
      }
    },
    
    onSearch() {
      this.currentPage = 1
      this.fetchData()
    },
    
    async onRefresh() {
      await axios.get(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_update_meter_data/?page=1&per_page=20`)
      this.fetchData()
    },
    
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        this.fetchData()
      }
    },
    
    jumpPage() {
      let p = parseInt(this.pageInput);
      if (!isNaN(p) && p >= 1 && p <= this.totalPages) {
        this.currentPage = p;
        this.fetchData();
      }
    },
    
    toggleTree(key) {
      this.$set(this.treeOpen, key, !this.treeOpen[key]);
    },

    selectMapImage(mapName) {
      this.selectedMap = mapName;
    },

    onClear() {
      this.query = {
        fac_state: '',
        factory_area: '',
        building_number: '',
        floor: '',
        fac_type: '',
        fac_id: '' // 确保重置为空字符串
      }
      this.currentPage = 1
      this.lastQuery = null // 重置lastQuery
      this.fetchData()
      this.fetchOptions() // 重新获取所有选项
    },

    // 新增：打印功能
    async printData() {
      try {
        console.log('=== 开始打印环境监控数据 ===');
        
        // 构建查询参数，设置per_page为500获取所有数据
        const params = this.buildPrintQueryParams();
        
        console.log('打印查询参数:', params);
        
        // 调用API获取所有数据
        const response = await axios.get(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_realtime_meter_message/`, {
          params: params
        });
        
        let allData = [];
        
        if (response.data) {
          allData = response.data.data || [];
          console.log('API返回数据:', allData);
          console.log('数据数组长度:', allData.length);
        } else {
          console.error('获取打印数据失败:', response.data);
          allData = this.tableData;
        }

        // 生成打印内容
        const printContent = `
          <div style="padding: 20px;">
            <h2 style="text-align: center; margin-bottom: 20px;">环境监控数据列表</h2>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              打印时间: ${new Date().toLocaleString('zh-CN')}
            </div>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              总记录数: ${allData.length} 条
            </div>
            <div style="margin-bottom: 10px; text-align: left; color: #666;">
              查询条件: ${this.getQueryConditions()}
            </div>
            <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
              <thead>
                <tr style="background: #f5f5f5;">
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">表具数值</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备类型</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备状态</th>

                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装位置</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">更新时间</th>
                </tr>
              </thead>
              <tbody>
                ${allData.map((item, index) => `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.fac_id || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.fac_name || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.fac_data || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${this.getDeviceTypeName(item.fac_type)}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.fac_state || '-'}</td>

                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.install_area || '-'}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.update_date || '-'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;
        
        // 打开打印窗口
        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
        
        console.log('=== 环境监控打印完成 ===');
        
      } catch (error) {
        console.error('打印环境监控数据失败:', error);
        alert('打印失败，请查看控制台');
      }
    },
    
    // 构建打印查询参数
    buildPrintQueryParams() {
      const params = {
        page: 1,
        per_page: 500, // 设置每页500条数据
        ...this.query
      };
      
      // 过滤掉空值参数
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      
      // 确保fac_id作为字符串发送
      if (this.query.fac_id) {
        params.fac_id = String(this.query.fac_id);
      }
      
      return params;
    },
    
    // 获取查询条件描述
    getQueryConditions() {
      const conditions = [];
      if (this.query.fac_state) conditions.push(`设备状态: ${this.query.fac_state}`);
      if (this.query.factory_area) conditions.push(`厂区: ${this.query.factory_area}`);
      if (this.query.building_number) conditions.push(`楼号: ${this.query.building_number}`);
      if (this.query.floor) conditions.push(`楼层: ${this.query.floor}`);
      if (this.query.fac_type) conditions.push(`设备类型: ${this.getDeviceTypeName(this.query.fac_type)}`);
      if (this.query.fac_id) conditions.push(`设备编号: ${this.query.fac_id}`);
      
      return conditions.length > 0 ? conditions.join(', ') : '全部';
    },
    
    // 获取设备类型名称
    getDeviceTypeName(facType) {
      const typeMap = {
        '0': '温湿度表',
        '1': '压力表'
      };
      return typeMap[facType] || facType || '-';
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.form-input {
  width: 200px;
  min-width: 200px;
}
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

.loading-text {
  color: #666;
  font-size: 14px;
}

.tree-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tree-list li {
  margin: 4px 0;
  padding: 2px 0;
}

.tree-node {
  cursor: pointer;
  color: #333;
  font-weight: 500;
}

.tree-leaf {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  color: #333;
  display: inline-block;
  transition: all 0.2s ease;
}

.tree-leaf:hover {
  background-color: #f0f0f0;
}

.tree-leaf.active {
  background-color: #e8f5e8;
  color: #4caf50;
  font-weight: bold;
}

.tree-node:hover {
  background-color: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;
}

.map-image-normal {
  width: 100%;
  max-width: 900px;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px #0001;
}

.map-image-small {
  width: 66.67%;
  max-width: 600px;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px #0001;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
